/* İletişim: the Google map loads only when the visitor asks for it, so nothing is sent to Google before that. */
document.querySelectorAll('[data-map]').forEach((map) => {
  map.querySelector('[data-map-load]')?.addEventListener('click', () => {
    const frame = document.createElement('iframe');
    frame.src = map.dataset.map;
    frame.title = map.dataset.mapTitle;
    frame.allowFullscreen = true;
    map.querySelector('[data-map-placeholder]').replaceWith(frame);
    frame.focus();
  });
});
